import { takeLatest, call, all, put } from 'redux-saga/effects';
import { GET_RATE_INFOS, getRateInfos } from './actions';
import { REQUEST } from 'utils/actionGenerator';
import urlHelper from './api';
import { fetchEntitySpawn } from 'store/saga';
function* fetchRateInfo(action) {
  const { demandId } = action.params;
  const request = urlHelper.fetchRateInfos(demandId);
  yield fetchEntitySpawn(request, getRateInfos, { toaster: { successMsg: 'Request successful' } });
}

function* mySaga() {
  yield takeLatest(GET_RATE_INFOS[REQUEST], fetchRateInfo);
}

export default mySaga;
